import { inject } from '@angular/core';
import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { HttpErrorResponse, HttpEvent } from '@angular/common/http';

import { catchError, Observable, throwError } from 'rxjs';

import { AuthService } from 'app/core/auth/auth.service';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const token = authService.accessToken;

    // Clone the request object
    let headers = req.headers.set('ngrok-skip-browser-warning', 'true');

    if (token) {
        headers = headers.set('Authorization', `Bearer ${token}`);
    } else {
        console.warn('[AuthInterceptor] No access token available for request:', req.url);
    }

    let newReq = req.clone({ headers });

    // Response
    return next(newReq).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                console.error(`[AuthInterceptor] Error ${error.status} on ${req.url}:`, error.message);

                if (error.status === 401) {
                    authService.signOut();
                }
            }

            return throwError(error);
        })
    );
};
